define('home/views/NotificationCardCollectionView',[
    'underscore',

    'core/bus',

    'home/views/ActivityCardCollectionView',
    'home/views/NotificationCardChannelPostView',
    'home/views/NotificationCardUpvoteView',
    'home/views/NotificationCardChannelRecommendView',
    'home/views/NotificationCardReplyView',
    'home/views/NotificationCardFollowView',
    'home/views/NotificationCardAnnouncementView',
    'home/views/NotificationCardThreadInviteView',
    'home/views/NotificationCardChannelInviteView',
    'home/views/NotificationCardCreateView',
    'home/views/NotificationCardAddModView',
    'home/views/NotificationCardHighlightPostView',
    'home/views/NotificationCardMentionView',
    'home/views/NotificationFeedEmptyView',
], function (
    _,

    coreBus,

    ActivityCardCollectionView,
    NotificationCardChannelPostView,
    NotificationCardUpvoteView,
    NotificationCardChannelRecommendView,
    NotificationCardReplyView,
    NotificationCardFollowView,
    NotificationCardAnnouncementView,
    NotificationCardThreadInviteView,
    NotificationCardChannelInviteView,
    NotificationCardCreateView,
    NotificationCardAddModView,
    NotificationCardHighlightPostView,
    NotificationCardMentionView,
    NotificationFeedEmptyView
) {
    'use strict';

    var NotificationCardCollectionView = ActivityCardCollectionView.extend({
        itemView: function (options) {
            var ItemView = NotificationCardCollectionView.ITEM_VIEWS[options.model.get('verb')];

            if (ItemView)
                return new ItemView({ model: options.model });
        },

        emptyView: NotificationFeedEmptyView,

        initialize: function () {
            ActivityCardCollectionView.prototype.initialize.apply(this, arguments);
            this.listenTo(this, 'after:item:added', this.onShowNotification);

            // TODO: Marionette _should_ have an event that occurs after all rendering is done,
            // but couldn't figure out how to get working atm
            var debouncedMessage = _.debounce(_.bind(coreBus.trigger, coreBus, 'after:render'), 100);
            this.listenTo(this, 'after:item:added', debouncedMessage);

            this.listenToOnce(this, 'showFirstItem', function () {
                coreBus.trigger('showFirstCard', 'notifications');
            });
        },

        /*
         * When the first notification is shown, clears the count of unread
         * notifications.
         */
        onShowNotification: function (view) {
            // Only clear for the first view
            // This covers the case where items are added later into the
            // collection view via the Show N New Items button
            if (!view.model ||
                view.model !== this.collection.at(0))
                return;

            this.model.trigger('clearUnreadCount');
        },
    }, {
        ITEM_VIEWS: {
            'favorite': NotificationCardUpvoteView,
            'reply': NotificationCardReplyView,
            'follow': NotificationCardFollowView,
            'send': NotificationCardAnnouncementView,
            'threadInvite': NotificationCardThreadInviteView,
            'channelInvite': NotificationCardChannelInviteView,
            'create': NotificationCardCreateView,
            'recommend': NotificationCardChannelRecommendView,
            'channel-post': NotificationCardChannelPostView,
            'add-mod': NotificationCardAddModView,
            'highlight': NotificationCardHighlightPostView,
            'mention': NotificationCardMentionView,
        },
    });

    return NotificationCardCollectionView;
});

